import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setStepVal = (payload) => ({
  type: actionTypes.SET_STEPVAL,
  payload,
});

export const loadPageData = () => ({
  type: actionTypes.LOAD_PAGE_DATA
});

export const resetUploadForm = (user) => ({
  type: actionTypes.RESET_UPLOAD_FORM,
  user,
});

export const changeFileRequest = (payload) => ({
  type: actionTypes.CHANGE_FILE_REQUEST,
  payload,
});

export const getProjectsForMaster = (masterId) => ({
  type: actionTypes.GET_PROJECTS_FOR_MASTER,
  masterId,
});

export const getUploadLogs = (params) => ({
  type: actionTypes.GET_UPLOAD_LOGS,
  params
});

export const setUploadData = (payload) => ({
  type: actionTypes.SET_UPLOAD_DATA,
  payload,
});

export const setMappedColumns = (payload) => ({
  type: actionTypes.SET_MAPPED_COLUMNS,
  payload,
});

export const updateMetadata = (payload) => ({
  type: actionTypes.UPDATE_METADATA,
  payload,
});

export const setAdditionalColumns = (columns) => {
  return ({
    type: actionTypes.SET_ADDITIONAL_COLUMNS,
    payload: columns,
  });
};

export const setFieldMappingTimeoutId = (timeoutId) => {
  return ({
    type: actionTypes.SET_FIELD_MAPPING_TIMEOUT_ID,
    payload: timeoutId,
  });
};

export const setSelectedColumns = (columns) => {
  return ({
    type: actionTypes.SET_SELECTED_COLUMNS,
    payload: columns,
  });
};

export const setActiveTab = (payload) => ({
  type: actionTypes.SET_ACTIVE_TAB,
  payload,
});

export const setUploadFile = (payload) => ({
  type: actionTypes.SET_UPLOAD_FILE,
  payload,
});

export const setReviewData = (payload) => ({
  type: actionTypes.SET_REVIEW_DATA,
  payload,
});

export const getUploadLogData = (payload) => ({
  type: actionTypes.GET_UPLOAD_LOG_DATA,
  payload,
});

export const viewUploadLog = (payload) => ({
  type: actionTypes.VIEW_UPLOAD_LOG,
  payload,
});

export const uploadFiles = (payload) => ({
  type: actionTypes.UPLOAD_FILES,
  payload,
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});

export const getMappedFields = (payload) => ({
  type: actionTypes.GET_MAPPED_FIELDS,
  payload,
});

export const runEtlProcess = (payload) => ({
  type: actionTypes.RUN_ETL_PROCESS,
  payload,
});

export const rejectReview = (payload) => ({
  type: actionTypes.REJECT_REVIEW,
  payload,
});

export const downloadFile = (payload) => ({
  type: actionTypes.DOWNLOAD_FILE,
  payload,
});

